/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable unicorn/no-array-method-this-argument */
/* eslint-disable unicorn/no-array-callback-reference */
/* eslint-disable no-console */
import Modal from '../../../components/Modal';
import { Events } from '../../../utils/dom/html-events';
import Manipulator from '../../../utils/dom/manipulator';
import Request, { ApiMode } from '../../../utils/request';
import EventHandler from '../../../utils/dom/event-handler';
import { ClassNames } from '../../../utils/dom/css-classes';
import SelectorEngine from '../../../utils/dom/selector-engine';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';

const IS_LOCAL = false;

const SELECTOR_MAIN_DIV = '.js-my-household-details-wrapper';
const SELECTOR_LINKED_HOUSEHOLD_MEMBERS = '.js-my-household-account-details__my-household-members';
const SELECTOR_BACK_BUTTON = '.js-my-household-back-button';

const SELECTOR_LEAVE_HOSUEHOLD_BUTTON = '.js-my-household-leave-household-button';
const SELECTOR_MY_HOUSEHOLD_LEAVE_HOUSEHOLD_MODAL = '.js-my-household-leave-household-modal';
const SELECTOR_MY_HOUSEHOLD_LEAVE_HOUSEHOLD_MODAL_EXIT_BUTTON = '.js-leave-household-modal-exit-button';
const SELECTOR_MY_HOUSEHOLD_LEAVE_HOUSEHOLD_MODAL_CONFIRM_BUTTON = '.js-leave-household-modal-confirm-button';
const SELECTOR_MY_HOUSEHOLD_LEAVE_HOUSEHOLD_MODAL_STAY_ON_PAGE_BUTTON = '.js-leave-household-modal-stay-on-page-button';

const SELECTOR_MY_HOUSEHOLD_PAGE_ERROR_CONTAINER = '.js-my-household-accounts-page__error-container';

class MyHousehold {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_MAIN_DIV);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get membersData() {
		return this._membersData;
	}
	set membersData(data) {
		this._membersData = data;
		if (this._membersData.length > 0) {
			this.renderPlayerList(data);
		}
	}
	init() {
		this.linkedMemberDetails = SelectorEngine.findOne(SELECTOR_LINKED_HOUSEHOLD_MEMBERS, this._wrapper);
		this.navigationBackButton = SelectorEngine.findOne(SELECTOR_BACK_BUTTON, this._wrapper);
		this.getHouseHoldMemberDetailsUrl = Manipulator.getDataAttribute(
			this._wrapper,
			'get-household-members-details-url'
		);

		this.loggedInMemberId = Manipulator.getDataAttribute(this._wrapper, 'logged-in-member-id');
		this.leaveHousholeApiUrl = Manipulator.getDataAttribute(this._wrapper, 'leave-household-api-url');

		// leave household modal selectors
		this.leaveHousholdButton = SelectorEngine.findOne(SELECTOR_LEAVE_HOSUEHOLD_BUTTON, this._wrapper);
		const leaveHouseHoldModal = SelectorEngine.findOne(SELECTOR_MY_HOUSEHOLD_LEAVE_HOUSEHOLD_MODAL, this._wrapper);

		this.leaveHouseholdModal = new Modal(leaveHouseHoldModal, { backdrop: 'static' });
		this.leaveHosuseholdModalExitButton = SelectorEngine.findOne(
			SELECTOR_MY_HOUSEHOLD_LEAVE_HOUSEHOLD_MODAL_EXIT_BUTTON,
			leaveHouseHoldModal
		);
		this.leaveHouseholdConfirmYesButton = SelectorEngine.findOne(
			SELECTOR_MY_HOUSEHOLD_LEAVE_HOUSEHOLD_MODAL_CONFIRM_BUTTON,
			leaveHouseHoldModal
		);
		this.leaveHouseholdConfirmNoButton = SelectorEngine.findOne(
			SELECTOR_MY_HOUSEHOLD_LEAVE_HOUSEHOLD_MODAL_STAY_ON_PAGE_BUTTON,
			leaveHouseHoldModal
		);

		// error container selectors
		this.myHouseholdMemberErrorContainer = SelectorEngine.findOne(
			SELECTOR_MY_HOUSEHOLD_PAGE_ERROR_CONTAINER,
			this._wrapper
		);
		this.myHouseholdMemberErrorText = SelectorEngine.findOne('.error-text', this.myHouseholdMemberErrorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this.myHouseholdMemberErrorContainer);

		if (this._closeErrorSnackBar) {
			EventHandler.on(this._closeErrorSnackBar, Events.Click, () => {
				this.myHouseholdMemberErrorContainer.classList.add(ClassNames.Hidden);
			});
		}
		this.fetchPlayersList();
		this.initLeaveHouseholdModalHandlers();
	}

	initLeaveHouseholdModalHandlers() {
		if (!this.leaveHousholdButton) return;

		EventHandler.on(this.leaveHousholdButton, Events.Click, () => {
			this.leaveHouseholdModal.show();
		});

		EventHandler.on(this.leaveHosuseholdModalExitButton, Events.Click, () => {
			this.leaveHouseholdModal.hide();
		});

		EventHandler.on(this.leaveHouseholdConfirmYesButton, Events.Click, () => {
			this.leaveHouseholdModal.hide();
			this.removeMemberApi(this.leaveHousholeApiUrl, this.loggedInMemberId, 'leavingHousehold');
		});

		EventHandler.on(this.leaveHouseholdConfirmNoButton, Events.Click, () => {
			this.leaveHouseholdModal.hide();
		});
	}

	async fetchPlayersList(refetchingStatus) {
		startLoadingAnimation(true);
		try {
			const url = this.getHouseHoldMemberDetailsUrl;
			const response = await Request.get(
				url,
				{ refetchingStatus },
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { success, errorMessage, infoTextToShow, memberDetails, actionButtonToShow } = response;
			stopLoadingAnimation();
			if (!success) {
				this.showErrorContainer(errorMessage || 'Something went wrong');
				this.membersData = [];
				return;
			}
			this.membersData = [...memberDetails];
			this.applyShowHideConfig(infoTextToShow, {
				hide: [ClassNames.FlexClass],
				show: [ClassNames.FlexClass]
			});
			this.applyShowHideConfig(actionButtonToShow);
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	applyShowHideConfig(configArray = [], options = {}) {
		configArray.forEach((cfg) => {
			const hideClass = cfg['hide-class'];
			const showClass = cfg['show-class'];

			if (hideClass) {
				this.toggleClassForSelector(`.${hideClass}`, {
					hide: true,
					remove: options.hide
				});
			}

			if (showClass) {
				this.toggleClassForSelector(`.${showClass}`, {
					show: true,
					add: options.show
				});
			}
		});
	}

	toggleClassForSelector(selector, { hide = false, show = false, add = [], remove = [] } = {}) {
		SelectorEngine.find(selector).forEach((el) => {
			remove.forEach((cls) => el.classList.remove(cls));

			add.forEach((cls) => el.classList.add(cls));

			if (hide) el.classList.add(ClassNames.Hidden);
			if (show) el.classList.remove(ClassNames.Hidden);
		});
	}

	showErrorContainer(message) {
		this.myHouseholdMemberErrorContainer.classList.remove(ClassNames.Hidden);
		this.myHouseholdMemberErrorText.innerHTML = message;
		this.myHouseholdMemberErrorContainer.scrollIntoView({
			behavior: 'smooth',
			block: 'center'
		});
	}

	renderPlayerList(membersData) {
		if (!this.linkedMemberDetails) return;

		this.linkedMemberDetails.innerHTML = membersData.map((item, index) => this.renderMembersData(item, index)).join('');

		// Attach event bubbling listeners
		const cards = SelectorEngine.find('lta-household-member-card', this.linkedMemberDetails);

		cards.forEach((card) => {
			card.addEventListener('navigate', (e) => {
				this.goToUrl(null, e.detail.url);
			});

			card.addEventListener('removeMember', async (e) => {
				await this.removeMemberApi(e.detail.url, e.detail.member.id, 'removingHouseHoldMember');
			});
		});
	}

	renderMembersData(member) {
		const details = member.details || [];
		const actions = member.actions || [];

		const detailAttrs = details
			.map((d, i) => {
				return `
                data-detail-${i}-label="${d.label}"
                data-detail-${i}-value="${d.value}"
                data-detail-${i}-type="${d.type}"
                data-detail-${i}-order="${d.order}"
            `;
			})
			.join(' ');

		const actionAttrs = actions
			.map((a, i) => {
				const modalConfig = a.removeConfirmationModalConfig || {};

				return `
                    data-action-${i}-key="${a.key}"
                    data-action-${i}-label="${a.label}"
                    data-action-${i}-icon="${a.icon}"
                    data-action-${i}-type="${a.type}"
                    data-action-${i}-url="${a.url}"

                    data-action-${i}-modal-subtitle="${modalConfig.subTitle || ''}"
                    data-action-${i}-modal-title="${modalConfig.title || ''}"
                    data-action-${i}-modal-info="${modalConfig.infoText || ''}"
                    data-action-${i}-modal-confirm-label="${modalConfig.confirmationButtonTitle || ''}"
                    data-action-${i}-modal-cancel-label="${modalConfig.cancelationButtonTitle || ''}"

                `;
			})
			.join(' ');

		return `
        <lta-household-member-card
            data-member-id="${member.id}"
            data-member-sfid="${member.sfid}"
            data-member-firstname="${member.firstName}"
            data-member-lastname="${member.lastName}"
            data-member-status="${member.status || ''}"
            data-details-count="${details.length}"
            ${detailAttrs}
            data-actions-count="${actions.length}"
            ${actionAttrs}
        >
        </lta-household-member-card>
    `;
	}

	goToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event?.currentTarget?.dataset?.target || '';
		window.location.href = `${rootUrl}${url}`;
	}

	async removeMemberApi(url, memberId, removeStatus) {
		startLoadingAnimation(true);
		try {
			const response = await Request.delete(url, { memberId }, { local: IS_LOCAL, req: { apiMode: ApiMode.LtaError } });
			const { success, errorMessage } = response;
			stopLoadingAnimation();
			if (!success) {
				this.showErrorContainer(errorMessage);
				return;
			}
			this.fetchPlayersList(removeStatus);
		} catch (error) {
			stopLoadingAnimation();
			this.showErrorContainer('Unable to remove member');
		}
	}
}

const globalMyHousehold = new MyHousehold();
export default globalMyHousehold;
